import { Button } from "@omni/ui/components/Button/button.component";
import { attempt } from "@omni/utils/function.utils";
import { cn } from "@omni/utils/styles/tw.merge";
import { useState } from "react";

import { Input } from "@/components/Form/Base/input.component";
import { InputGroup } from "@/components/Form/Base/inputGroup.component";
import { Modal } from "@/components/General/Modal/modal";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type ShareModalComponentProps = {
    open: boolean;
    value: string;
    onClose: () => void;
};

const ShareModalComponent = ({
    open,
    value,
    onClose
}: ShareModalComponentProps) => {
    const { t } = useGranite();
    const [isCopied, setCopied] = useState(false);

    const doCopy = () => {
        setCopied(false);
        attempt(() => {
            navigator.clipboard.writeText(value);
            setCopied(true);
        }, undefined);
    };

    return (
        <Modal
            modalType={ModalType.Share}
            autoFocus={true}
            centered={true}
            open={open}
            setOpen={onClose}
            title={t("modal.share.title")}
        >
            <InputGroup className={cn("tw:mt-6 tw:mb-4")}>
                <Input
                    disabled={false}
                    readOnly={true}
                    value={value}
                />
                <Button
                    type={"button"}
                    onClick={doCopy}
                    color={isCopied ? "success" : "primary"}
                >
                    {isCopied ? t("modal.share.copied") : t("modal.share.copy")}
                </Button>
            </InputGroup>
        </Modal>
    );
};

export { ShareModalComponent };
